import axios from 'axios';
// import authentication from './../setAuthToken';
// import jwtdecode from 'jwt-decode';

export const UPDATE_VEHICLES = 'UPDATE_VEHICLES';
// export const FETCH_VEHICLES = 'FETCH_VEHICLES';
export const RT_UPDATE_VEHICLES = 'RT_UPDATE_VEHICLES'; // RealTime
// import { ADD_POST, DELETE_POST, FETCH_POST } from './types';

// dtFrom='2018-11-10T04:01:43.000Z';
//   dtTo='2018-11-11T12:02:43.000';
const apiUrl_local = 'http://localhost:5000/api/geo'; //geo.
const apiUrl = 'https://alpha.skylo.io/api/devices/history/ids/dd7295fa-6c65-484d-b38d-30df3bc31c0c';
const token =  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRqYXlAZm9yZC5jb20iLCJzeXN0ZW1Sb2xlIjoic3lzdGVtVXNlciIsImlhdCI6MTU0MTAwNzAzMiwiaXNzIjoiaHR0cDovL3dlYi1zZXJ2ZXJzLWRldi0xNDI1MzI1MDI4LnVzLXdlc3QtMi5lbGIuYW1hem9uYXdzLmNvbSIsInN1YiI6ImUyMmE2MjlkLWRlYTAtNDc0Yi04YzY5LTFlODQwYmZkMzRmYSIsImp0aSI6IjY0Nzk2YWIwLTlhYTItNGY3Ny04OTk4LWI1MzMzYzhlMmI5OCJ9.aIGEX_qigixaA17dcO0KNJay-R_704FDaugfkIAeVLA" ;
const vehicleId = 'dd7295fa-6c65-484d-b38d-30df3bc31c0c';
const config = {
  headers: {'Authorization': 'Bearer '+token}
};
export const fetchVehicles = (dtFrom,dtTo) => { 
  // dtFrom='2018-11-10T04:01:43.000Z';
  // dtTo='2018-11-11T12:02:43.000';
  return (dispatch) => {
    return axios.get(`${apiUrl}`,{
      params: {
        since: dtFrom,
        until:dtTo
      },
      headers: {'Authorization': 'Bearer '+token} 
     } )
      .then(response => {
        console.log('-----------div id data',response.data["devices"][vehicleId]);
        dispatch(updateVehicles(response.data["devices"][vehicleId]))
      })
      .catch(error => {
        throw(error);
      });
  }; 

}
// fetch local:
export const fetchVehicles1   = (dtFrom,dtTo) => { 
  // dtFrom='2018-11-10T04:01:43.000Z';
  // dtTo='2018-11-11T12:02:43.000';
  // dtFrom='2018-12-04T21:59:09.643Z';
  // dtTo='2018-12-12T06:10:10.960Z';   
  return (dispatch) => {
    return axios.get(`${apiUrl_local}`,{
      params: {
        since: dtFrom,
        until:dtTo
      },
        } )
      .then(response => {
        if (response.data)
        console.log('-----------div id data',response.data["devices"][vehicleId]);       
        dispatch(updateVehicles(response.data["devices"][vehicleId]))
      })
      .catch(error => {
        // alert('Data not available. Pl. try different date range');
        console.log(error);
        throw(error);
      });
  }; 

}

export const updateVehicles =  (vehicles) => {
  console.log("vehicles data", vehicles);
  return {
    type: UPDATE_VEHICLES,
    vehicles
  }
  // return {
  //   type: ADD_POST,
  //   payload: {
  //     _id: data._id,
  //     title: data.title,
  //     body: data.body
  //   }
  // }
};


// RealTime
export const rtUpdateVehicles = (vehicles) => {
  // console.log("vehicles data", vehicles);
  return {
    type: RT_UPDATE_VEHICLES,
    vehicles
  }
}

// function fetchPosts(subreddit) {
//   return dispatch => {
//     dispatch(requestPosts(subreddit))
//     return fetch(`https://www.reddit.com/r/${subreddit}.json`)
//       .then(response => response.json())
//       .then(json => dispatch(receivePosts(subreddit, json)))
//   }
// }



// export const createPost = ({ title, body }) => {
//   return (dispatch) => {
//     return axios.post(`${apiUrl}/add`, {title, body})
//       .then(response => {
//         dispatch(createPostSuccess(response.data))
//       })
//       .catch(error => {
//         throw(error);
//       });
//   };
// };

// export const createPostSuccess =  (data) => {
//   return {
//     type: ADD_POST,
//     payload: {
//       _id: data._id,
//       title: data.title,
//       body: data.body
//     }
//   }
// };

// export const deletePostSuccess = id => {
//   return {
//     type: DELETE_POST,
//     payload: {
//       id
//     }
//   }
// }

// export const deletePost = id => {
//   return (dispatch) => {
//     return axios.get(`${apiUrl}/delete/${id}`)
//       .then(response => {
//         dispatch(deletePostSuccess(response.data))
//       })
//       .catch(error => {
//         throw(error);
//       });
//   };
// };

// export const fetchPost = (posts) => {
//   return {
//     type: FETCH_POST,
//     posts
//   }
// };

// export const fetchAllPosts = () => {
//   return (dispatch) => {
//     return axios.get(apiUrl)
//       .then(response => {
//         dispatch(fetchPosts(response.data))
//       })
//       .catch(error => {
//         throw(error);
//       });
//   };
// };